import { CustomReportListItem } from './CustomReportListItem.jsx'
import '../ReportGrid.scss'
import './customReports.scss'
import { useCustomReportList } from '../../../../api'
import { LoaderSpinner } from '../../Loader.js'

export const CustomReportList = ({ activeReportId }) => {
  const { data, isLoading, error } = useCustomReportList()

  if (isLoading || !data) {
    return <LoaderSpinner />
  }

  if (error || data.length === 0) {
    return (
      <section className='report-blocks default-view'>
        <div className='default-block'>
          <div>
            <h2>No Reports</h2>
            <p>Select "Create Report" to save your current blocks</p>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className='report-blocks'>
      {data.map((block) => (
        <CustomReportListItem active={block.id === activeReportId} key={block.id} report={block} />
      ))}
    </section>
  )
}

export default CustomReportList
